//Local Authority Having Jurisdiction
export const LAHJJurisdictions = [
    'Half Moon Bay',
    'Menlo Park',
    'Mountain View',
    'Redwood City',
    'San Jose',
    'Santa Clara County',
    'Unincorporated San Mateo',
];

export const WaterJurisdictions = [
    'City of Mountain View Public',
    'Cal Water',
    'San Jose Water',
    'East Palo Alto Water',
];
